import classNames from 'classnames';
import { parse } from '../../../util/urlHelpers';
import css from './TabSelector.module.css';

// DDG custom component

const TabSelector = ({ location, onTabChange }) => {
  const params = parse(location.search);
  const currentCategory = params.pub_categoryLevel1;

  return (
    <div className={css.root}>
      <button 
        className={classNames(css.tab, { [css.activeTab]: currentCategory === 'tour' })}
        onClick={() => onTabChange('tours')}
      >
        Tours
      </button>
      <button 
        className={classNames(css.tab, { [css.activeTab]: currentCategory === 'course' })}
        onClick={() => onTabChange('courses')}
      >
        Courses
      </button>
    </div>
  );
};

export default TabSelector; 
